
  export default {
    name: `AeqSpan`,
    props: {
      label: {
        type: String,
        default: ``
      }
    },
    data() {
      return {}
    }
  }
